export const TYPE_TOOLTIP_PLACEHOLDER =
  'Identify the type of communications work involved in this record. This helps track both visible and behind-the-scenes work across your team.';
